import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import "./CustomerJourneySection.css";

// Replace this with your actual image
import sampleImage from "../../../assets/home/aboutus/idea.png";

const CustomerJourneySection = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, {
    margin: "-100px 0px -100px 0px",
    once: false,
  });

  return (
    <section ref={sectionRef} className="customer-journey-section">
      <motion.div
        className="cj-content"
        initial={{ opacity: 0 }}
        animate={{ opacity: isInView ? 1 : 0 }}
        transition={{ duration: 0.7 }}
      >
        {/* Left Column: Image */}
        <div className="cj-left">
          <div className="image-container">
            <img
              src={sampleImage}
              alt="ASIC Team Collaboration"
              className="main-image"
            />
          </div>
        </div>

        {/* Right Column: Label, heading, bullets */}
        <div className="cj-right">
          <span className="cj-label">OUR BUSINESS GOAL</span>
          <h2 className="cj-heading">
            Excellence from RTL to Sign-Off
          </h2>

          <div className="cj-bullets">
            <div className="bullet-item">
              <div className="bullet-icon">
                <i className="fas fa-code"></i>
              </div>
              <div className="bullet-text">
                <h3 className="bullet-title">Robust RTL Design</h3>
                <p className="bullet-desc">
                  Craft synthesizable, modular SystemVerilog RTL that meets your  
                  power, performance, and area targets from day one.
                </p>
              </div>
            </div>

            <div className="bullet-item">
              <div className="bullet-icon">
                <i className="fas fa-vial"></i>
              </div>
              <div className="bullet-text">
                <h3 className="bullet-title">Comprehensive Verification</h3>
                <p className="bullet-desc">
                  Deploy UVM-based testbenches and formal checks to exhaustively  
                  validate functionality across all corner cases.
                </p>
              </div>
            </div>

            <div className="bullet-item">
              <div className="bullet-icon">
                <i className="fas fa-rocket"></i>
              </div>
              <div className="bullet-text">
                <h3 className="bullet-title">Fast Time-to-Market</h3>
                <p className="bullet-desc">
                  Streamline your ASIC flow with automated regressions and  
                  expert support to hit your tape-out deadlines.
                </p>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default CustomerJourneySection;